import { formatCSV } from './format-csv.js';
import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import { HoneycombTileData } from '../types/honeycomb.js';

/**
 * Builds CSV from map raw data and downloads the file
 *
 * @param data -
 */
export const buildAndDownloadCsv = (data: HoneycombTileData[]) => {
  const csvString = formatCSV(data);
  downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
};
